import mixpanel from 'mixpanel-browser';
import { createAction, handleActions } from 'redux-actions';

import Agent from '../../api/Agent';

export const getAllSavedShifts = createAction('GET_ALL_SAVED_SHIFTS');
export const clearSavedShifts = createAction('CLEAR_SAVED_SHIFTS');
export const setSavedShiftStatus = createAction('SET_SAVED_SHIFT_STATUS');

import { getShift } from '../shiftdetail';
import { shiftsListDisplay } from '../nurseshift';
import mixpanelConstants from '../../constants/mixpanel';

const INITIAL_STATE = {
	CurrentPage: 1,
	NumberOfPages: 1,
	shifts: [],
	shiftStatus: false
};

export default handleActions(
	{
		CLEAR_SAVED_SHIFTS: (state) => ({ ...INITIAL_STATE, shiftStatus: state.shiftStatus }),
		GET_ALL_SAVED_SHIFTS: (state, action) => ({
			...state,
			CurrentPage: action.payload.current_page,
			NumberOfPages: action.payload.total_page,
			shifts: action.payload.bookmarks
		}),
		SET_SAVED_SHIFT_STATUS: (state, action) => ({ ...state, shiftStatus: action.payload })
	},
	INITIAL_STATE
);

export const saveShiftForLater = (shiftId) => (dispatch, getState) => {
	Agent.saveShiftForLater(shiftId).then(() => {
		let shiftDetails =
			getState().nurseshift &&
			getState().nurseshift.nursedashboardList &&
			getState().nurseshift.nursedashboardList.shifts &&
			getState().nurseshift.nursedashboardList.shifts.find((shift) => shift.shift_id == shiftId);

		dispatch(shiftsListDisplay('block'));
		if (shiftId) dispatch(getShift(shiftId));

		if (shiftDetails) {
			mixpanel.track(mixpanelConstants.BOOKMARK_SAVED, {
				address: shiftDetails.address,
				city: shiftDetails.city,
				organization: shiftDetails.organization,
				organizationId: shiftDetails.organization_id,
				roleList: shiftDetails.role_list,
				shiftDate: shiftDetails.shift_date,
				shiftEnd: shiftDetails.shift_end,
				shiftId: shiftId,
				shiftStart: shiftDetails.shift_start
			});
		}
	});
};

export const deleteSavedShift = (id, shiftId) => (dispatch, getState) => {
	Agent.deleteSavedShift(id).then(() => {
		dispatch(shiftsListDisplay('block'));
		if (shiftId) dispatch(getShift(shiftId));

		let shiftDetails =
			getState().bookmarks.shifts.find((shift) => shift.id == id) ||
			getState().nurseshift.nursedashboardList.shifts.find((shift) => shift.shift_id == shiftId);

		mixpanel.track(mixpanelConstants.BOOKMARK_DELETED, {
			bookmarkId: id,
			organization: shiftDetails.organization || shiftDetails.organization_title,
			shiftDate: shiftDetails.shift_date,
			shiftEnd: shiftDetails.shift_end || shiftDetails.end_time,
			shiftId: shiftId,
			shiftStart: shiftDetails.shift_start || shiftDetails.start_time
		});
	});
};
